<ng-container *ngIf="agGridParams.value">
  <div class="cell-container full-height">
      <ng-container [ngSwitch]="agGridParams.value.format_type">
        <ng-container *ngSwitchCase="'rating'">
          <div class="display-flex flex-align-center justify-content full-height flex-grow">
            <app-adloop-rating [value]="agGridParams.value[agGridParams.colDef.params.formatted]"
                               *ngIf="agGridParams.value[agGridParams.colDef.params.formatted]; else noValue"></app-adloop-rating>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'phases'">
          <div class="display-flex flex-align-center justify-content full-height flex-grow">
            <app-cell-phases class="full-height full-width" [values]="agGridParams.value[agGridParams.colDef.params.formatted]"></app-cell-phases>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="cell"></ng-container>
        </ng-container>
      </ng-container>
    <div class="display-flex justify-content flex-align-center full-height w-30px"
         *ngIf="agGridParams.value.format_type !== 'phases' && agGridParams.colDef.params.report.type !== 'cycle'">
      <mat-icon class="icon-trends cursor ml-10 color-grey-light" (click)="openTrendsDialog()"
                *ngIf="agGridParams.value.type !== 'page_total' &&
                agGridParams.value[agGridParams.colDef.params.formatted] &&
                agGridParams.colDef.params.formatted !== 'comparison_percentage_formatted_value'">timeline</mat-icon>
    </div>
  </div>
  <ng-template #cell>
    <div class="display-flex flex-align-center justify-content-end full-height flex-grow">
        <div>
          <div class="display-flex flex-align-center justify-content-end" [ngClass]="{bold: agGridParams.colDef.params.report.formatted.compare?.on}">
            {{ agGridParams.value.formatted_value || '-' }}
          </div>
          <div class="fs-12 display-flex flex-align-center justify-content-end" *ngIf="agGridParams.colDef.params.report.formatted.compare?.on">
            {{ agGridParams.value.comparison_formatted_value || '-' }}
            <span class="ml-10" [ngClass]="'color-' + agGridParams.value.comparison_color ">{{ agGridParams.value.comparison_percentage_formatted_value || '-' }}</span>
          </div>
        </div>
    </div>
  </ng-template>
  <ng-template #noValue>-</ng-template>
</ng-container>
